module.exports = __webpack_public_path__ + "img/rabbit.ba8c505d.svg";